import { render } from "./job-breadcrumb.vue?vue&type=template&id=63c73c20"
import script from "./job-breadcrumb.vue?vue&type=script&lang=js"
export * from "./job-breadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__